export const recordTabs = ['ratings', 'reviews', 'lists', 'saved', 'comments'];
export const recordEndpoints = {
  albums: '/me/reviews',
  tracks: '/me/track-ratings',
  lists: '/me/lists',
  saved: '/me/saved',
  comments: '/me/comments',
};
export const formatRecordCount = (count) =>
  count == null ? '—' : count > 999 ? '999+' : String(count);
export const hasReviewBody = (item) => Boolean(item.review?.content?.trim());
export const activeRecords = (items) =>
  items?.filter((item) => item.category?.trim().toLowerCase() !== 'news');
export function recordCounts(data, profile) {
  return {
    ratings:
      data.tracks == null
        ? undefined
        : (data.albums?.length ?? profile.reviewsCount ?? 0) + data.tracks.length,
    reviews: data.albums
      ? data.albums.filter(hasReviewBody).length
      : (profile.writtenReviewsCount ?? 0),
    lists: data.lists?.length ?? profile.playlistsCount ?? 0,
    saved: activeRecords(data.saved)?.length,
    comments: activeRecords(data.comments)?.length,
  };
}
export function unwrapRecords(response) {
  const data = response?.data?.data ?? response?.data;
  if (!Array.isArray(data)) throw new Error('Invalid music record response');
  return data;
}
export function albumRecordPath(album) {
  if (!album) return null;
  if (album.slug) return `/reviews/${album.slug}`;
  return album.id != null ? `/reviews/local/${encodeURIComponent(album.id)}` : null;
}
const namedPath = (base, value) =>
  value && (value.slug ?? value.id) != null
    ? `/${base}/${encodeURIComponent(value.slug ?? value.id)}`
    : null;
export function recordPath(item, tab, kind = 'albums') {
  if (tab === 'ratings' && kind === 'tracks')
    return albumRecordPath({ slug: item.albumSlug, id: item.albumId });
  const album = albumRecordPath(item.album);
  const review =
    album && item.review?.id != null
      ? `${album}/user-reviews/${encodeURIComponent(item.review.id)}`
      : null;
  if (tab === 'ratings') return album;
  if (tab === 'reviews') return review;
  if (tab === 'lists') return namedPath('lists', item);
  const category = item.category?.trim().toLowerCase();
  let path = ['review', 'reviews'].includes(category)
    ? review
    : ['playlist', 'lists'].includes(category)
      ? namedPath('lists', item.list)
      : category === 'notice'
        ? namedPath('notice', item.notice)
        : category === 'feed'
          ? namedPath('feed', item.feed)
          : category === 'albums'
            ? album
            : null;
  // The native comment surface only links these three supported destinations.
  if (tab === 'comments') {
    if (
      !['review', 'reviews', 'playlist', 'lists', 'notice'].includes(category) ||
      item.comment?.id == null
    )
      return null;
    path = path ? `${path}/comment/${encodeURIComponent(item.comment.id)}` : null;
  }
  return path;
}
export function filterRecords(items = [], query = '') {
  const q = query.trim().toLocaleLowerCase();
  if (!q) return items;
  return items.filter((item) =>
    [
      item.title,
      item.type,
      item.artistName,
      item.albumTitle,
      item.album?.title,
      item.album?.genres?.join(' '),
      item.artist?.name,
      item.review?.content,
      item.list?.title,
      item.author?.nickname,
      item.comment?.content,
      item.notice?.title,
      item.feed?.title,
    ].some((value) =>
      String(value ?? '')
        .toLocaleLowerCase()
        .includes(q),
    ),
  );
}

export function compactRecordText(value) {
  const text = value?.replace(/\s+/g, ' ').trim() ?? '';
  return text.length > 110 ? `${text.slice(0, 110).trim()}…` : text;
}
